import { format } from 'date-fns';
import {
  resolveAvailableTickets,
  resolveMaxTickets,
} from '@/utils/ticketAvailability';

const getSaleStatus = function (event) {
  return event?.saleStatus ?? event?.sale_status ?? null;
};

export const isNotSoldOut = function (event, counter) {
  if (!counter) {
    counter = 0;
  }

  const availableTickets = resolveAvailableTickets(event);
  if (availableTickets !== null) {
    return availableTickets - counter > 0;
  }

  const maxTickets = resolveMaxTickets(event);
  if (!maxTickets) {
    return true;
  }

  const unavailableTickets = Number(event.numTickets ?? event.num_tickets ?? 0);
  return maxTickets - unavailableTickets - counter > 0;
};

export const saleOpen = function (event) {
  const saleStatus = getSaleStatus(event);
  if (saleStatus === 'open') return true;
  if (saleStatus === 'closed' || saleStatus === 'upcoming') return false;

  // Support both old (snake_case) and new (camelCase) API formats
  const saleFrom = event.saleFrom ?? event.sale_from;
  const saleUntil = event.saleUntil ?? event.sale_until;

  const start = saleFrom ? new Date(saleFrom) : null;
  const end = saleUntil ? new Date(saleUntil) : null;
  const today = new Date();

  if (!start && !end) return true;
  if (start && !end) return today >= start;
  if (!start && end) return today <= end;
  return today >= start && today <= end;
};

export const saleClosedMsg = function (event) {
  const saleStatus = getSaleStatus(event);

  // Support both old (snake_case) and new (camelCase) API formats
  const saleFrom = event.saleFrom ?? event.sale_from;
  const saleUntil = event.saleUntil ?? event.sale_until;

  const start = saleFrom ? new Date(saleFrom) : null;
  const end = saleUntil ? new Date(saleUntil) : null;
  const today = new Date();

  if (saleStatus === 'upcoming' && !start) {
    return 'De verkoop is nog niet gestart.';
  }

  if (saleStatus === 'closed' && !end) {
    return 'De verkoop werd gesloten.';
  }

  if (start && !end) {
    if (today <= start) {
      return `De verkoop gaat open op ${format(
        new Date(start),
        'dd-MM-yyyy HH:mm'
      )}`;
    }
  }

  if (!start && end) {
    if (today >= end) {
      return `De verkoop werd gesloten op ${format(
        new Date(end),
        'dd-MM-yyyy HH:mm'
      )}`;
    }
  }

  if (today < start) {
    return `De verkoop gaat open op ${format(
      new Date(start),
      'dd-MM-yyyy HH:mm'
    )}`;
  } else if (today > end) {
    return `De verkoop werd gesloten op ${format(
      new Date(end),
      'dd-MM-yyyy HH:mm'
    )}`;
  }
};

export const getEventCount = function (counters, eventId) {
  if (counters['event_' + eventId]) {
    return counters['event_' + eventId];
  }
  return 0;
};
